import { useContext } from 'react';
import CommonPropsContext from '../contexts/CommonPropsContext';
var useCommonProps = function () {
    return useContext(CommonPropsContext);
};
export default useCommonProps;
//# sourceMappingURL=useCommonProps.js.mapimport { useContext } from 'react';
import CommonPropsContext from '../contexts/CommonPropsContext';
var useCommonProps = function () {
    return useContext(CommonPropsContext);
};
export default useCommonProps;
//# sourceMappingURL=useCommonProps.js.map